import React from 'react';
import { PieChart, Pie, Cell } from 'recharts';

const SentimentGauge = ({ score = -10 }) => {
  // Create data for the gauge
  const data = [
    { name: 'Negative', value: 33 },
    { name: 'Neutral', value: 34 },
    { name: 'Positive', value: 33 },
  ];

  // Define colors for each segment
  const COLORS = ['#ED6B60', '#F5A261', '#76D5A5'];

  // Calculate the normalized position (0-1) for the indicator
  const normalizedPosition = (score + 100) / 200;

  // Determine sentiment category based on score
  let sentimentLabel = 'Neutral';
  let sentimentColor = COLORS[1]; // orange

  if (score < -30) {
    sentimentLabel = 'Negative';
    sentimentColor = COLORS[0]; // red
  } else if (score < 0) {
    sentimentLabel = 'Slightly negative';
    sentimentColor = COLORS[1]; // orange
  } else if (score < 30) {
    sentimentLabel = 'Slightly positive';
    sentimentColor = COLORS[1]; // orange
  } else {
    sentimentLabel = 'Positive';
    sentimentColor = COLORS[2]; // green
  }

  // Calculate angle for needle
  const startAngle = 180;
  const endAngle = 0;
  const needleAngle = startAngle - normalizedPosition * (startAngle - endAngle);
  const needleRadians = (needleAngle * Math.PI) / 180;
  const needleX = Math.cos(needleRadians);
  const needleY = Math.sin(needleRadians);

  // Function to get position on the gauge arc
  const getPositionOnArc = (percentage) => {
    const angle = startAngle - percentage * (startAngle - endAngle);
    const radians = (angle * Math.PI) / 180;
    return {
      x: 200 + Math.cos(radians) * 115,
      y: 150 + Math.sin(radians) * 115,
    };
  };

  return (
    <div className="relative flex flex-col items-center mb-10">
      {/* Recharts Gauge */}
      <div className="relative">
        <PieChart width={600} height={240}>
          <Pie
            data={data}
            cx={300}
            cy={200}
            startAngle={180}
            endAngle={0}
            innerRadius={110}
            outerRadius={130}
            paddingAngle={2}
            dataKey="value"
            stroke="none"
            isAnimationActive={false}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>

          {/* Score indicator - LARGER with multiple rings for visibility */}
          {/* <circle
            cx={300 + needleX * 115}
            cy={0 + needleY * 115}
            r={10}
            fill="#ffffff"
            stroke="#000000"
            strokeWidth={2}
          />
          <circle
            cx={300 + needleX * 115}
            cy={-28 + needleY * 115}
            r={10}
            fill={sentimentColor}
            stroke="#ffffff"
            strokeWidth={4}
          /> */}

          {/* 0 label at top */}
          <text
            x={300}
            y={66}
            textAnchor="middle"
            dominantBaseline="middle"
            className="text-sm fill-gray-600"
          >
            0
          </text>

          {/* -100 label at left */}
          <text
            x={150}
            y={200}
            textAnchor="middle"
            dominantBaseline="middle"
            className="text-sm fill-gray-600"
          >
            -100
          </text>

          {/* 100 label at right */}
          <text
            x={450}
            y={200}
            textAnchor="middle"
            dominantBaseline="middle"
            className="text-sm fill-gray-600"
          >
            100
          </text>
        </PieChart>

        {/* Value and label */}
        <div
          className="absolute left-1/2 top-1/2 -translate-x-1/2 text-center"
          style={{ width: '160px' }}
        >
          <div className="text-gray-600 text-sm">Score</div>
          <div className="text-4xl font-bold text-gray-800">{score}</div>
          <span
            className="inline-block px-4 py-1 rounded-full text-white text-xs mt-3"
            style={{ backgroundColor: sentimentColor }}
          >
            {sentimentLabel}
          </span>
        </div>
      </div>
    </div>
  );
};

export default SentimentGauge;
